"use client";

import React, { useMemo } from "react";
import Section from "../components/Section";
import {
  Card,
  CardContent,
  Grid2,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@repo/ui";
import Image from "next/image";
import useServiceContent from "@/hooks/useServiceContent";
import { DynamicIcon } from "lucide-react/dynamic";

type ExamFormatProps = {
  sectionInfo: PageSections;
  data: {
    examFormat: ServiceContent;
    image?: string;
  };
};

const ExamFormat = ({ data, sectionInfo }: ExamFormatProps) => {
  const { heading, image, list, description } = useServiceContent(
    data.examFormat
  );

  const listIconMap: Record<number, any> = {
    0: "notebook-text",
    1: "file-question",
    3: "check-circle",
    2: "clock",
    4: "languages",
    5: "book",
  };
  const imagePath = useMemo(() => {
    if (image) {
      return image;
    }
    if (data.image) {
      return data.image;
    }
    return undefined;
  }, [image, data.image]);
  return (
    <Section
      className={sectionInfo.sectionClass}
      id={sectionInfo.sectionId}
      data-title={sectionInfo.name}
    >
      <Card>
        <CardContent>
          <Grid2 container spacing={5} align="center">
            <Grid2 size={{ xs: 12, sm: 12, md: 8, lg: 8 }}>
              <Typography variant="h2" gutterBottom>
                {heading}
              </Typography>
              {description && <Typography>{description}</Typography>}
              {list && (
                <List>
                  {list?.map((item, index) => (
                    <ListItem key={`exam-format-${index}`}>
                      <ListItemIcon className="text-secondary-main">
                        <DynamicIcon
                          name={listIconMap[index] || "circle-check"}
                        />
                      </ListItemIcon>
                      <ListItemText>{item}</ListItemText>
                    </ListItem>
                  ))}
                </List>
              )}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
              {imagePath && list && (
                <Image
                  src={imagePath}
                  width={300}
                  height={300}
                  alt={heading}
                  className="w-full h-auto"
                />
              )}
            </Grid2>
          </Grid2>
        </CardContent>
      </Card>
    </Section>
  );
};

export default ExamFormat;
